export default function CircleButton({ icon: Icon, active = false, onClick, label, size = 'lg' }) {
  const isSmall = size === 'sm';
  const isMedium = size === 'md';
  const dimension = isSmall ? 'w-11 h-11' : isMedium ? 'w-12 h-12' : 'w-14 h-14';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className="flex flex-col items-center gap-2 cursor-pointer border-none bg-transparent p-0 active:scale-[0.98] transition-transform duration-200 ease-out"
    >
      <span
        className={`flex items-center justify-center rounded-full transition-colors duration-200 ${dimension} ${
          active ? 'bg-white/[0.1]' : 'bg-white/[0.04]'
        }`}
      >
        <Icon
          size={isSmall ? 20 : isMedium ? 21 : 23}
          color={active ? '#0a84ff' : 'rgba(255, 255, 255, 0.4)'}
        />
      </span>
      {label && (
        <span
          style={{
            fontSize: '13px',
            fontWeight: active ? 600 : 500,
            fontFamily: '"Public Sans", sans-serif',
            color: active ? 'rgba(255, 255, 255, 0.92)' : 'rgba(255, 255, 255, 0.45)',
          }}
        >
          {label}
        </span>
      )}
    </button>
  );
}
